import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MtnaEmptyStateModule, MtnaTrackByPropertyPipeModule } from '@mtna/core-angular';
import { MtnaConsumerToManagerFileInformationPipeModule, MtnaGetFileDownloadUrlPipeModule } from '@mtna/file-manager-angular';

import { RdsResourceDocumentationComponent } from './resource-documentation.component';

@NgModule({
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatTableModule,
    MatTooltipModule,
    MtnaConsumerToManagerFileInformationPipeModule,
    MtnaEmptyStateModule,
    MtnaGetFileDownloadUrlPipeModule,
    MtnaTrackByPropertyPipeModule,
  ],
  declarations: [RdsResourceDocumentationComponent],
  exports: [RdsResourceDocumentationComponent],
})
export class RdsResourceDocumentationModule {}

export * from './resource-documentation.component';
